import { render, staticRenderFns } from "./AccountSpecification.vue?vue&type=template&id=0987f409&scoped=true"
import script from "./AccountSpecification.vue?vue&type=script&lang=ts"
export * from "./AccountSpecification.vue?vue&type=script&lang=ts"
import style0 from "./AccountSpecification.vue?vue&type=style&index=0&id=0987f409&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0987f409",
  null
  
)

export default component.exports